import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("load", () => {
      this.resize();
    });
  }

  resize() {
    const iframe = this.element;
    iframe.style.height = iframe.contentWindow.document.body.scrollHeight + "px";
  }
}
